module.exports = __webpack_public_path__ + "static/media/photo7.791b030f.jpg";